/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 1sKx9ffix1qWmdscEUQHh6
// Component: 9QJHZ6j77LRS
import * as React from "react";
import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  hasVariant,
  renderPlasmicSlot,
  useDollarState
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: 1sKx9ffix1qWmdscEUQHh6/styleTokensProvider
import "@plasmicapp/react-web/lib/plasmic.css";
import projectcss from "./plasmic.module.css"; // plasmic-import: 1sKx9ffix1qWmdscEUQHh6/projectcss
import sty from "./PlasmicModuleNav.module.css"; // plasmic-import: 9QJHZ6j77LRS/css

createPlasmicElementProxy;

export const PlasmicModuleNav__VariantProps = new Array("byPlacement");

export const PlasmicModuleNav__ArgProps = new Array("navButtonSlot");

const $$ = {};

function PlasmicModuleNav__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const stateSpecs = React.useMemo(
    () => [
      {
        path: "byPlacement",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.byPlacement
      }
    ],

    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });
  const styleTokensClassNames = _useStyleTokens();
  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        styleTokensClassNames,
        sty.root,
        {
          [sty.rootbyPlacement_navLogo]: hasVariant(
            $state,
            "byPlacement",
            "navLogo"
          ),
          [sty.rootbyPlacement_navOnboarding]: hasVariant(
            $state,
            "byPlacement",
            "navOnboarding"
          )
        }
      )}
    >
      {renderPlasmicSlot({
        defaultContents: null,
        value: args.navButtonSlot
      })}
    </div>
  );
}

const PlasmicDescendants = {
  root: ["root"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicModuleNav__ArgProps,
          internalVariantPropNames: PlasmicModuleNav__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicModuleNav__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicModuleNav";
  } else {
    func.displayName = `PlasmicModuleNav.${nodeName}`;
  }
  return func;
}

export const PlasmicModuleNav = Object.assign(
  // Top-level PlasmicModuleNav renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    // Metadata about props expected for PlasmicModuleNav
    internalVariantProps: PlasmicModuleNav__VariantProps,
    internalArgProps: PlasmicModuleNav__ArgProps
  }
);

export default PlasmicModuleNav;
/* prettier-ignore-end */
